export enum AutoExportDestinationType {
    Ftps,
    Sftp,
}
